import axios from "axios";
import baseApi from "./baseApi";
import "./baseApi";

const appSettings = () => axios.get("AppSetting");
const getProvince = () => axios.get("AppSetting/GetProvince");
const getDashboard = () => axios.get(`AppSetting/GetDashboard`, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
// const getDepartment = () => axios.get(`AppSetting/GetDepartment`, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });


// const log = (error) => axios.post("clientlog", { error: JSON.stringify(error) });

export default {
    appSettings,
    // log,
    getProvince,
    getDashboard,
    // getDepartment
};